import React, { useEffect } from 'react'
import { Col, Form, Row } from 'react-bootstrap'
import LabelCustomSmall from '../../label-custom-small'
import { useState } from 'react'
import { getEmpsJobsAPI } from '../../../services/employee'
import moment from 'moment'
import { useSelector } from 'react-redux'

export default function ProfileJopPosition() {
  const profile = useSelector((state) => state.loginReducer.profile)
  const orgId = profile.org_id
  const code = profile.code
  const [dataDetail, setDataDetail] = useState()
  const [isLoading, setIsLoading] = useState(true)
  useEffect(() => {
    const getEmpsJobs = async () => {
      const body = { orgId, code }
      setIsLoading(true)
      const result = await getEmpsJobsAPI(body)
      setIsLoading(false)
      if (!result) return
      if (result.status) {
        setDataDetail(result.result[0])
      }
    }
    if (orgId && code) {
      getEmpsJobs()
    }
    return () => {}
  }, [orgId, code])
  const SkeletonBody = <span className="placeholder col-12"></span>
  return (
    <>
      <Row style={{ rowGap: '15px' }}>
        <Col xl={12} className="d-flex justify-content-between mb-0">
          <div>
            <span className="my-auto text-primary">Job Position</span>
            <span
              className="small fw-light "
              style={{
                fontSize: '10px',
              }}
            >
              {' '}
              (PD Only)
            </span>
          </div>
        </Col>
        <div
          className="small fw-light mt-0 text-secondary"
          style={{
            fontSize: '10px',
          }}
        >
          หากต้องการแก้ไขข้อมูล Job Position โปรดติดต่อแผนก PD
        </div>
        <ColFrom>
          <LabelCustomSmall className={`fw-bold`}>รหัสพนักงาน</LabelCustomSmall>
          {isLoading ? (
            SkeletonBody
          ) : (
            <div className="fw-light small">
              {dataDetail?.code ?? ''}
              <span className="text-secondary small">
                ({dataDetail?.recruitment_no ?? ' ไม่พบใบสมัครงาน '})
              </span>
            </div>
          )}
        </ColFrom>
        <ColFrom>
          <LabelCustomSmall className={`fw-bold`}>Finger ID</LabelCustomSmall>
          {isLoading ? (
            SkeletonBody
          ) : (
            <div className="fw-light small">{dataDetail?.finger_id ?? ''}</div>
          )}
        </ColFrom>
        <ColFrom>
          <LabelCustomSmall className={`fw-bold`}>Username</LabelCustomSmall>

          {isLoading ? (
            SkeletonBody
          ) : (
            <div className="fw-light small">{dataDetail?.username ?? '-'}</div>
          )}
        </ColFrom>
        <ColFrom>
          <LabelCustomSmall className={`fw-bold`}>
            Email (Office)
          </LabelCustomSmall>
          {isLoading ? (
            SkeletonBody
          ) : (
            <div className="fw-light small">{dataDetail?.email ?? '-'}</div>
          )}
        </ColFrom>

        <ColFrom>
          <LabelCustomSmall className={`fw-bold`}>สายงาน</LabelCustomSmall>

          {isLoading ? (
            <>
              {SkeletonBody}
              {SkeletonBody}
            </>
          ) : (
            <>
              <div className="fw-light small">
                {dataDetail?.division_en ?? ''}
                {' ('}
                {dataDetail?.division || ''}
                {')'}
              </div>
              <div className="fw-light small">
                {dataDetail?.division_th ?? ''}
              </div>
            </>
          )}
        </ColFrom>
        <ColFrom>
          <LabelCustomSmall className={`fw-bold`}>ฝ่าย</LabelCustomSmall>

          {isLoading ? (
            <>
              {SkeletonBody}
              {SkeletonBody}
            </>
          ) : (
            <>
              <div className="fw-light small">
                {dataDetail?.faction_en ?? '-'}
                {' ('}
                {dataDetail?.faction || ''}
                {')'}
              </div>
              <div className="fw-light small">
                {dataDetail?.faction_th ?? '-'}
              </div>
            </>
          )}
        </ColFrom>

        <ColFrom>
          <LabelCustomSmall className={`fw-bold`}>แผนก</LabelCustomSmall>
          {isLoading ? (
            <>
              {SkeletonBody}
              {SkeletonBody}
            </>
          ) : (
            <>
              <div className="fw-light small">
                {dataDetail?.department_en ?? '-'} {' ('}
                {dataDetail?.department || ''}
                {')'}
              </div>
              <div className="fw-light small">
                {dataDetail?.department_th ?? '-'}
              </div>
            </>
          )}
        </ColFrom>
        <ColFrom>
          <LabelCustomSmall className={`fw-bold`}>ทีม</LabelCustomSmall>
          {isLoading ? (
            <>
              {SkeletonBody}
              {SkeletonBody}
            </>
          ) : (
            <>
              <div className="fw-light small">{dataDetail?.team_en ?? '-'}</div>
              <div className="fw-light small">{dataDetail?.team_th ?? '-'}</div>
            </>
          )}
        </ColFrom>
        <ColFrom>
          <LabelCustomSmall className={`fw-bold`}>ตำแหน่ง</LabelCustomSmall>

          {isLoading ? (
            <>
              {SkeletonBody}
              {SkeletonBody}
            </>
          ) : (
            <>
              <div className="fw-light small">
                {dataDetail?.position_en ?? '-'}
              </div>
              <div className="fw-light small">
                {dataDetail?.position_th ?? '-'}
              </div>
            </>
          )}
        </ColFrom>
        <ColFrom>
          <LabelCustomSmall className={`fw-bold`}>Level</LabelCustomSmall>
          {isLoading ? (
            <>{SkeletonBody}</>
          ) : (
            <div className="fw-light small">{dataDetail?.level_id ?? '-'}</div>
          )}
        </ColFrom>
        <ColFrom>
          <LabelCustomSmall className={`fw-bold`}>
            ผู้บังคับบัญชา
          </LabelCustomSmall>
          {isLoading ? (
            <>{SkeletonBody}</>
          ) : (
            <>
              <div className="fw-light small">
                {dataDetail?.report_to_name_en ?? '-'}{' '}
                {dataDetail?.report_to_surname_en} (
                {dataDetail?.report_to ?? '-'})
              </div>
              <div className="fw-light small">
                {`${dataDetail?.report_to_name_th ?? ''} ${
                  dataDetail?.report_to_surname_th ?? ''
                }`}
              </div>
            </>
          )}
        </ColFrom>
        <ColFrom>
          <LabelCustomSmall className={`fw-bold`}>Supervisor</LabelCustomSmall>
          {isLoading ? (
            <>{SkeletonBody}</>
          ) : (
            <>
              <div className="fw-light small">
                {`${dataDetail?.supervisor_name_en ?? ''} ${
                  dataDetail?.supervisor_surname_en ?? ''
                } (${dataDetail?.supervisor ?? '-'})`}
              </div>
              <div className="fw-light small">
                {`${dataDetail?.supervisor_name_th ?? ''} ${
                  dataDetail?.supervisor_surname_th ?? ''
                }`}
              </div>
            </>
          )}
        </ColFrom>
        <ColFrom>
          <LabelCustomSmall className={`fw-bold`}>เบอร์ภายใน</LabelCustomSmall>
          {isLoading ? (
            <>{SkeletonBody}</>
          ) : (
            <div className="fw-light small">{dataDetail?.intra_tel ?? ''}</div>
          )}
        </ColFrom>

        {/* Certificate */}
        {/* <ColFrom>
            <LabelCustomSmall
              className={`fw-bold`}
            >
              Certificate
            </LabelCustomSmall>
            <div className="fw-light small">{dataDetail?.certificate_detail ?? '-'}</div>
          </ColFrom> */}

        <Col xl={12}>
          <div className="border-bottom mt-3 mb-3"> </div>
        </Col>
        <ColFrom>
          <LabelCustomSmall className={`fw-bold`}>
            สถานะพนักงาน
          </LabelCustomSmall>
          {isLoading ? (
            <>{SkeletonBody}</>
          ) : (
            <div className="fw-light small">{dataDetail?.status ?? ''}</div>
          )}
        </ColFrom>
        {/* {isResign && (
            <>
              {dataDetail && dataDetail.is_head && (
                <ColFrom>
                  <LabelCustomSmall
                    className={`fw-bold`}
                  >
                    ผู้รับผิดชอบแทน
                  </LabelCustomSmall>

                  <div className="fw-light small">
                    {dataDetail?.report_to_name_th ?? ''}
                  </div>
                </ColFrom>
              )}

              <ColFrom>
                <LabelCustomSmall
                  className={`fw-bold`}
                >
                  สาเหตุการลาออก
                </LabelCustomSmall>

                <div className="fw-light small">{dataDetail?.resign ?? ''}</div>
              </ColFrom>

              <ColFrom>
                <LabelCustomSmall
                  className={`fw-bold`}
                >
                  วันที่พ้นสภาพ
                </LabelCustomSmall>

                <div className="fw-light small">
                  {moment(dataDetail?.end_date)
                    .format('DD/MM/YYYY') ?? ''}
                </div>
              </ColFrom>
            </>
          )} */}
        <ColFrom>
          <LabelCustomSmall className={`fw-bold`}>
            ประเภทพนักงาน
          </LabelCustomSmall>

          {isLoading ? (
            <>{SkeletonBody}</>
          ) : (
            <div className="fw-light small">{dataDetail?.type ?? ''}</div>
          )}
        </ColFrom>

        <ColFrom>
          <LabelCustomSmall className={`fw-bold`}>กะทำงาน</LabelCustomSmall>

          {isLoading ? (
            <>{SkeletonBody}</>
          ) : (
            <div className="fw-light small">{`${
              dataDetail?.shift || '-'
            }`}</div>
          )}
        </ColFrom>
        <ColFrom>
          <LabelCustomSmall className={`fw-bold`}>
            สถานะทดลองงาน
          </LabelCustomSmall>
          {isLoading ? (
            <>{SkeletonBody}</>
          ) : (
            <div className="fw-light small">{dataDetail?.probation ?? ''}</div>
          )}
        </ColFrom>

        <ColFrom>
          <LabelCustomSmall className={`fw-bold`}>
            วันที่เริ่มงาน
          </LabelCustomSmall>
          {isLoading ? (
            <>{SkeletonBody}</>
          ) : (
            <div className="fw-light small">
              {moment(dataDetail?.start_date)
                // .add(543, 'year')
                .format('DD/MM/YYYY') ?? ''}
            </div>
          )}
        </ColFrom>
        <ColFrom>
          <LabelCustomSmall className={`fw-bold`}>วันที่บรรจุ</LabelCustomSmall>
          {isLoading ? (
            <>{SkeletonBody}</>
          ) : (
            <div className="fw-light small">
              {dataDetail && dataDetail.employed_date
                ? moment(dataDetail.employed_date, 'YYYY-MM-DD', true).isValid()
                  ? moment(dataDetail.employed_date).format('DD/MM/YYYY')
                  : '-'
                : '-'}
            </div>
          )}
        </ColFrom>
        <ColFrom>
          <LabelCustomSmall className={`fw-bold`}>
            วันที่เริ่มสัญญา
          </LabelCustomSmall>
          {isLoading ? (
            <>{SkeletonBody}</>
          ) : (
            <div className="fw-light small">
              {dataDetail && dataDetail.contract_start_date
                ? moment(
                    dataDetail.contract_start_date,
                    'YYYY-MM-DD',
                    true,
                  ).isValid()
                  ? moment(dataDetail.contract_start_date).format('DD/MM/YYYY')
                  : '-'
                : '-'}
            </div>
          )}
        </ColFrom>
        <ColFrom>
          <LabelCustomSmall className={`fw-bold`}>
            วันที่สิ้นสุดสัญญา
          </LabelCustomSmall>
          {isLoading ? (
            <>{SkeletonBody}</>
          ) : (
            <div className="fw-light small">
              {dataDetail && dataDetail.contract_end
                ? moment(dataDetail.contract_end, 'YYYY-MM-DD', true).isValid()
                  ? moment(dataDetail.contract_end)
                      // .add(543, 'year')
                      .format('DD/MM/YYYY')
                  : '-'
                : '-'}
            </div>
          )}
        </ColFrom>
        <ColFrom>
          <LabelCustomSmall className={`fw-bold`}>
            วันทำงานวันสุดท้าย
          </LabelCustomSmall>
          {isLoading ? (
            <>{SkeletonBody}</>
          ) : (
            <div className="fw-light small">
              {dataDetail?.last_date
                ? moment(dataDetail?.last_date).format('DD/MM/YYYY')
                : '-'}
            </div>
          )}
        </ColFrom>
        <ColFrom>
          <LabelCustomSmall className={`fw-bold`}>
            วันที่พ้นสภาพ
          </LabelCustomSmall>
          {isLoading ? (
            <>{SkeletonBody}</>
          ) : (
            <div className="fw-light small">
              {dataDetail?.end_date && dataDetail?.end_date !== '0000-00-00'
                ? moment(dataDetail?.end_date).format('DD/MM/YYYY')
                : '-'}
            </div>
          )}
        </ColFrom>
        <ColFrom>
          <LabelCustomSmall className={`fw-bold`}>
            สาเหตุการลาออก
          </LabelCustomSmall>
          {isLoading ? (
            <>{SkeletonBody}</>
          ) : (
            <div className="fw-light small">{dataDetail?.resign ?? '-'}</div>
          )}
        </ColFrom>
        {dataDetail && dataDetail.is_head && (
          <ColFrom>
            <LabelCustomSmall className={`fw-bold`}>
              ผู้รับผิดชอบแทน
            </LabelCustomSmall>
            {isLoading ? (
              <>{SkeletonBody}</>
            ) : (
              <div className="fw-light small">
                {dataDetail?.new_report_to ?? '-'}
              </div>
            )}
          </ColFrom>
        )}

        <ColFrom>
          <LabelCustomSmall className={`fw-bold`}>Assets ID</LabelCustomSmall>
          {isLoading ? (
            <>{SkeletonBody}</>
          ) : (
            <div className="fw-light small">{dataDetail?.asset_id ?? '-'}</div>
          )}
        </ColFrom>

        <Col xl={12}>
          <div className="border-bottom mt-3 mb-3"> </div>
        </Col>

        <ColFrom>
          <LabelCustomSmall className={`fw-bold`}>การเดินทาง</LabelCustomSmall>
          {isLoading ? (
            <>{SkeletonBody}</>
          ) : (
            <div className="fw-light small">
              {dataDetail?.travelling ?? '-'}
            </div>
          )}
        </ColFrom>
        <ColFrom>
          <LabelCustomSmall className={`fw-bold`}>ค่าโทรศัพท์</LabelCustomSmall>
          {isLoading ? (
            <>{SkeletonBody}</>
          ) : (
            <div className="fw-light small">
              {dataDetail?.phone_packet ?? '-'}
            </div>
          )}
        </ColFrom>

        <ColFrom>
          <LabelCustomSmall className={`fw-bold`}>OT เหมาจ่าย</LabelCustomSmall>

          {isLoading ? (
            <>{SkeletonBody}</>
          ) : (
            <div className="fw-light small">
              {dataDetail?.ot_flat_rate ?? '-'}
            </div>
          )}
        </ColFrom>
        <ColFrom>
          <LabelCustomSmall className={`fw-bold`}>
            OT วันทำงานปกติ{' '}
            <span style={{ cursor: 'pointer' }}>
              <i
                className="bi bi-info-circle text-secondary"
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                title="OT เหมาจ่ายสำหรับวันทำงานปกติ"
                style={{ fontSize: '1rem', verticalAlign: 'middle' }}
              ></i>
            </span>
          </LabelCustomSmall>

          {isLoading ? (
            <>{SkeletonBody}</>
          ) : (
            <div className="fw-light small">
              {dataDetail?.ot_shift === 1 ? 'มี' : 'ไม่มี'}
            </div>
          )}
        </ColFrom>

        <ColFrom>
          <LabelCustomSmall className={`fw-bold`}>ค่าภาษา</LabelCustomSmall>

          {isLoading ? (
            <>{SkeletonBody}</>
          ) : (
            <div className="fw-light small">{dataDetail?.lang_fee ?? '-'}</div>
          )}
        </ColFrom>
        <ColFrom>
          <LabelCustomSmall className={`fw-bold`}>
            ค่าประสบการณ์
          </LabelCustomSmall>

          {isLoading ? (
            <>{SkeletonBody}</>
          ) : (
            <div className="fw-light small">{dataDetail?.exp_fee ?? '-'}</div>
          )}
        </ColFrom>

        <ColFrom>
          <LabelCustomSmall className={`fw-bold`}>
            ค่ากะเหมาจ่าย
          </LabelCustomSmall>

          {isLoading ? (
            <>{SkeletonBody}</>
          ) : (
            <div className="fw-light small">
              {dataDetail?.shift_flat_rate ?? '-'}
            </div>
          )}
        </ColFrom>

        <Col xl={12}>
          <div className="border-bottom mt-3 mb-3"> </div>
        </Col>

        <ColFrom>
          <LabelCustomSmall className={`fw-bold`}>
            ประเภทการจ่ายเงิน
          </LabelCustomSmall>
          {isLoading ? (
            <>{SkeletonBody}</>
          ) : (
            <div className="fw-light small">{dataDetail?.payment ?? '-'}</div>
          )}
        </ColFrom>
        <ColFrom>
          <LabelCustomSmall className={`fw-bold`}>บัญชีธนาคาร</LabelCustomSmall>
          {isLoading ? (
            <>{SkeletonBody}</>
          ) : (
            <div className="fw-light small">{dataDetail?.bank ?? '-'}</div>
          )}
        </ColFrom>
        <ColFrom>
          <LabelCustomSmall className={`fw-bold`}>เลขบัญชี</LabelCustomSmall>

          {isLoading ? (
            <>{SkeletonBody}</>
          ) : (
            <div className="fw-light small">
              {dataDetail?.account_no ?? '-'}
            </div>
          )}
        </ColFrom>
      </Row>
    </>
  )
}

const ColFrom = (props) => {
  const { children, className = '', ...other } = props

  return (
    <Col xl={3} xs={6} md={4} className={` ${className}`} {...other}>
      {children}
    </Col>
  )
}
